function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "15",
  height: "15",
  viewBox: "0 0 15 15",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("path", {
  d: "M13.817 12.904l-2.41-2.392a5.854 5.854 0 00-.659-8.018 5.843 5.843 0 00-8.036.22 5.854 5.854 0 00-.22 8.042 5.843 5.843 0 008.012.66l2.391 2.392a.65.65 0 00.922 0 .65.65 0 000-.904zM6.86 11.415a4.549 4.549 0 01-4.547-4.55A4.549 4.549 0 016.86 2.314a4.549 4.549 0 013.216 7.768 4.546 4.546 0 01-3.216 1.333z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: ".5",
  fillRule: "evenodd"
})));